import { Avatar } from '@material-ui/core'
import AccountCircle from '@material-ui/icons/AccountCircle'
import ExitToApp from '@material-ui/icons/ExitToApp'
import React from 'react'
import { MenuItemLink, UserMenu } from 'react-admin'
import Logout from './Logout'
import { useUser } from './auth/client'

const MyUserMenu = (props) => {
  const { user } = useUser()
  return (
    <div>
      <UserMenu
        {...props}
        label="user info"
        icon={<Avatar src={user?.picture} imgProps={{ referrerPolicy: 'no-referrer' }} />}
        logout={<Logout />}
        style={{ bottom: 0, position: 'absolute' }}
      >
        <MenuItemLink
          to="/"
          primaryText={user?.name}
          leftIcon={<Avatar src={user?.picture} imgProps={{ referrerPolicy: 'no-referrer' }} />}
          style={{ padding: 15 }}
        />
      </UserMenu>
    </div>
  )
}

MyUserMenu.defaultProps = {
  label: 'ra.auth.user_menu',
  icon: <AccountCircle />,
  logout: <ExitToApp />,
}

export default MyUserMenu
